import type {LocalEvent,NotificationDelivery} from './local-api';
type Step={key:string;at:number};
const time=(value:string|null|undefined)=>{const n=value?Date.parse(value):NaN;return Number.isFinite(n)?n:null;};
export function alarmTimeline(event:LocalEvent,delivery?:NotificationDelivery){
 const steps:Step[]=[];
 const add=(key:string,at:number|null|undefined)=>{if(typeof at==='number'&&Number.isFinite(at)&&at>=0)steps.push({key,at});};
 add('serverEvent',time(event.occurredAt));
 // Internal protocol/provider stages remain in the evidence, not the customer's timeline.
 if(delivery){add('sent',delivery.acceptedAt??delivery.providerAcceptedAt);add('phoneReceipt',delivery.receivedAt);add('phoneOpen',delivery.openedAt);}
 add('humanAcknowledgement',time(event.caregiverAckAt));
 return steps.sort((a,b)=>a.at-b.at);
}
